var scope_0 = require('/Users/greg/Desktop/projects/portfolio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/467a00abdac90e8ed8fe74979b3086dd.js').default;
var scope_1 = require('/Users/greg/Desktop/projects/portfolio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    